import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layout/main-layout.component';
import { AppGuardService } from './core/services/app-guard.service';
import { planRoutes } from './routes/plan.route';
import { adminRoutes } from './routes/admin.route';
import { excelRoutes } from './routes/excel.route';
export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./features/login/page/login.component')
        .then((m) => m.LoginComponent),
  },
  {
    path: 'sso-login/:ticket',
    loadComponent: () =>
      import('./features/login/page/login.component').then(
        (m) => m.LoginComponent
      ),
  },
  {
    path: 'sso-login',
    loadComponent: () =>
      import('./features/login/page/login.component').then(
        (m) => m.LoginComponent
      ),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./features/forgot-password/page/forgotPassword.component')
        .then((m) => m.ForgotPasswordComponent),
  },
  {
    path: 'change-password',
    loadComponent: () =>
      import('./features/change-password/changePassword.component')
        .then((m) => m.ChangePasswordComponent),
  },
  {
    path: 'notfound',
    loadComponent: () =>
      import('./shared/components/not-found/not-found.component')
        .then((m) => m.NotFoundComponent),
  },
  {
    path: 'access-denied',
    loadComponent: () =>
      import('./shared/components/access-denied/access-denied.component')
        .then((m) => m.AccessDeniedComponent),
  },
  {
    path: 'sample',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/sample-screen/sampleScreen.component')
            .then((m) => m.SampleScreenComponent),
      },
      {
        path: 'add',
        loadComponent: () =>
          import('./features/sample-screen/addSample/AddSampleScreen.component')
            .then((m) => m.AddSampleScreenComponent),
      },
    ]
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivateChild: [AppGuardService],
    children: [
      //TemplateUi
      {
        path: 'template',
        loadComponent: () =>
          import('./features/templateUi/templateUi.component')
            .then((m) => m.TemplateUiComponent),
      },
      //Sample screen

      {
        path: 'home',
        loadComponent: () =>
          import('./features/dashboard/page/Dashboard.component')
            .then((m) => m.DashboardComponent),
      },
      {
        path: 'plan-dashboard/:planType',
        loadComponent: () =>
          import('./features/dashboard/plan-dashboard/PlanDashboard.component')
            .then((m) => m.PlanDashboardComponent),
      },
      { path: 'plan', children: planRoutes },
      { path: 'admin', children: adminRoutes },
      { path: 'excel-designer', children: excelRoutes },
      {
        path: 'quan-ly-bieu-mau',
        loadComponent: () =>
          import('./features/quan-ly-bieu-mau/page/quan-ly-bieu-mau.component')
            .then((m) => m.QuanLyBieuMauComponent),
      },

      {
        path: 'quan-ly-bieu-mau/chi-tiet/:maBieuMau',
        loadComponent: () =>
          import('./features/quan-ly-bieu-mau/component/chi-tiet/page/chi-tiet.component')
            .then((m) => m.ChiTietComponent),
      },

      {
        path: 'thong-ke-chi-tieu',
        loadComponent: () =>
          import('./features/report/thong-ke-chi-tieu/page/thong-ke-chi-tieu.component')
            .then((m) => m.ThongKeChiTieuComponent),
      },
      {
        path: 'warehouse-check',
        loadComponent: () =>
          import('./features/api-reference/page/warehouse-check.component')
            .then((m) => m.WarehouseCheckComponent),
      },
      {
        path: '**',
        redirectTo: 'home',
      },

    ],
  },
];
